import React from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FilterListIcon from '@mui/icons-material/FilterList';
import HistoryIcon from '@mui/icons-material/History';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Routes from 'routes';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import * as Styles from '../DeliveryPortalPage.styles';

interface MenuLinkProps {
  label: string;
  href: string;
  icon: JSX.Element;
}

const MenuLink: React.FC<MenuLinkProps> = ({ label, href, icon }) => {
  const { pathname } = useLocation();
  const isActive = pathname === href;

  return (
    <Styles.CustomLink to={href}>
      <Button variant="contained" startIcon={icon} disabled={isActive}>
        {label}
      </Button>
    </Styles.CustomLink>
  );
};

interface DeliveryPortalMenuProps {
  onFilter?: () => void;
}

const DeliveryPortalMenu: React.FC<DeliveryPortalMenuProps> = ({ onFilter }) => {
  const [language] = useLanguage();
  const { pathname } = useLocation();
  const showFilterButton = pathname === Routes.DeliveryPortalList.path;

  return (
    <Grid container spacing={2}>
      {showFilterButton ? (
        <Grid item>
          <Button variant="contained" startIcon={<FilterListIcon />} onClick={onFilter}>
            {language.DeliveryPortal.Menu.Filter}
          </Button>
        </Grid>
      ) : null}
      <Grid item>
        <MenuLink
          icon={<ListAltIcon />}
          href={Routes.DeliveryPortalList.path}
          label={language.DeliveryPortal.Menu.All}
        />
      </Grid>
      <Grid item>
        <MenuLink
          icon={<HistoryIcon />}
          href={Routes.DeliveryPortalUploadList.path}
          label={language.DeliveryPortal.Menu.UploadList}
        />
      </Grid>
      <Grid item>
        <MenuLink
          icon={<FileUploadIcon />}
          href={Routes.DeliveryPortalUpload.path}
          label={language.DeliveryPortal.Menu.Upload}
        />
      </Grid>
    </Grid>
  );
};

export default DeliveryPortalMenu;
